import { isDefined } from "@clipboard-health/util-ts";
import { get } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import { useCurrentUserId } from "../../lib/useCurrentUserId";
import { type VisitWorker, visitWorkerSchema } from "../types";

const WORKER_URL = `${environmentConfig.REACT_APP_API_MAIN_URL}/api/agentprofile/:workerId/facility/:workplaceId`;

/*
 * @deprecated
 * Deprecated use src/appV2/Worker/api/useWorker.ts from proper folder structure
 */
export function useWorker(
  workerId?: string,
  options: UseQueryOptions<VisitWorker, unknown, VisitWorker> = {}
) {
  const workplaceId = useCurrentUserId();

  return useQuery({
    queryKey: ["workers", workerId],
    queryFn: async () => {
      const response = await get({
        url: WORKER_URL.replace(":workerId", workerId!).replace(":workplaceId", workplaceId!),
        responseSchema: visitWorkerSchema,
      });

      return response.data;
    },
    retry: 0,
    staleTime: 1000 * 60 * 5,
    refetchInterval: 1000 * 60 * 10,
    enabled: isDefined(workerId) && isDefined(workplaceId),
    ...options,
  });
}
